type SectionConfigElem = {
	sectionName: string;
	sectionWeight?: number;
};

const percentsToAbsolute = (
	percents: number[] | undefined,
	panesLen: number,
) => {
	if (!percents || percents.length === 0) return [];
	// Если передали уже абсолютные проценты соответствующие количеству панелей — используем их
	if (percents.length === panesLen)
		return percents.map((p) => Number(p.toFixed(3)));
	// Если передали для 2-панелей [p] — преобразуем в [p, 100-p]
	if (panesLen === 2 && percents.length === 1)
		return [
			Number(percents[0].toFixed(3)),
			Number((100 - percents[0]).toFixed(3)),
		];
	return [];
};

const matchesKey = (
	sectionName: string,
	key: string,
	aliasList: string[] = [],
) =>
	sectionName === key ||
	sectionName.endsWith(`_${key}`) ||
	sectionName.includes(key) ||
	aliasList.some((a) => sectionName.includes(a));

// Подобно calculateCurrrentWeight — принимаем panes (React nodes) и percentsState
export const calculateCurrentSections = (
	panes: React.ReactNode[] | undefined,
	percentsState: number[] | undefined,
	aliases?: Record<string, string[]>,
) => {
	try {
		if (!panes || panes.length === 0) return null;

		const paneKeys = panes
			.map((p) => String((p as React.ReactElement)?.key ?? "").trim())
			.filter(Boolean);
		if (paneKeys.length === 0) return null;

		// Получаем абсолютные проценты
		const abs = percentsToAbsolute(percentsState, paneKeys.length);
		if (!abs || abs.length !== paneKeys.length) return null;

		const percents = abs.map((p) => Number(p.toFixed(3)));

		if (typeof window === "undefined") return { percents };

		const raw = localStorage.getItem("sectionsConfig");
		let parsed: SectionConfigElem[] = [];
		try {
			parsed = raw ? (JSON.parse(raw) as SectionConfigElem[]) : [];
		} catch (e) {
			parsed = [];
		}

		// Обновим или создадим записи в sectionsConfig
		const updated =
			parsed && parsed.length > 0
				? parsed.map((s) => ({ ...s }))
				: ([] as SectionConfigElem[]);

		// Опциональные алиасы (по-умолчанию пустой)
		const defaultAliases: Record<string, string[]> = {};

		paneKeys.forEach((key, i) => {
			const w = percents[i] ?? 0;
			const aliasList = aliases?.[key] ?? defaultAliases[key] ?? [];
			const idx = updated.findIndex(
				(s) => s && matchesKey(s.sectionName, key, aliasList),
			);
			if (idx !== -1) {
				updated[idx].sectionWeight = Number(w);
			} else {
				// создаём новую запись
				updated.push({ sectionName: key, sectionWeight: Number(w) });
			}
		});

		// Сохраняем обратно и логируем для отладки
		try {
			localStorage.setItem("sectionsConfig", JSON.stringify(updated));
		} catch (e) {
			// eslint-disable-next-line no-console
			console.warn(
				"calculateCurrentSections: failed to save sectionsConfig",
				e,
			);
		}

		return { percents, updatedConfig: updated };
	} catch (err) {
		// eslint-disable-next-line no-console
		console.warn("calculateCurrentSections failed", err);
		return null;
	}
};

export default calculateCurrentSections;
